/* MapCookies -- handles cookies for google maps */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define([], factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.returnExports = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {

  var STATION_DISPLAY_COOKIE = "show_stations";
  var SHAKE_MAP_OPACITY_COOKIE = "shake_map_opacity";
  var DEFAULT_SHAKE_MAP_OPACITY = 0.7;

  var module = {};

  module.toggleStations = function () {
    if (Cookies.get(STATION_DISPLAY_COOKIE) === "false") {
      Cookies.set(STATION_DISPLAY_COOKIE, "true");
    }
    else {
      Cookies.set(STATION_DISPLAY_COOKIE, "false");
    }
    window.location.assign(window.location.href);
  };

  module.hasShowStationsSelected = function () {
    var value = Cookies.get(STATION_DISPLAY_COOKIE);
    if (value == null) {
      return true;
    }
    return value === "true";
  };

  module.setShakeMapOpacity = function (newOpacity) {
    window.groundMotionOverlay.setOpacity(newOpacity);
    Cookies.set(SHAKE_MAP_OPACITY_COOKIE, newOpacity);
  };

  module.getShakeMapOpacity = function () {
    var value = Cookies(SHAKE_MAP_OPACITY_COOKIE);
    if (value == null) {
      return DEFAULT_SHAKE_MAP_OPACITY;
    }
    return parseFloat(value);
  };

  Cookies.defaults = { expires: 7, path: "/" };

  return module;
}));